import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp32} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.primary};
  background-image: repeating-conic-gradient(
    ${props => props.theme.colors.border.subtle} 0% 25%,
    ${props => props.theme.colors.background.primary} 0% 50%
  );
  background-size: ${props => props.theme.primitives.size.sizing20} ${props => props.theme.primitives.size.sizing20};
`
